export enum AuthenticateTypes {
    SET_AUTHENTICATE_RESPONSE = "SET_AUTHENTICATE_RESPONSE"
}

export interface SetAuthenticateResponse extends ReduxAction {
    type: AuthenticateTypes.SET_AUTHENTICATE_RESPONSE;
    payload: IAuthenticateResponse;
}
